module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "context"
  }, [_c('div', {
    staticClass: "phonePic"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/app/phonePic.png"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "bannerTit mart114"
  }, [_vm._v("木材码头全新升级")]), _vm._v(" "), _c('p', {
    staticClass: "bannerCon"
  }, [_vm._v("木材行业交易平台 APP，邀你共享"), _c('span', {
    staticClass: "edition"
  }, [_vm._v("v2.2.1")])]), _vm._v(" "), _c('p', {
    staticClass: "btn"
  }, [_c('a', {
    staticClass: "na_app_btn",
    attrs: {
      "href": "http://app.emulian.com/download/android/"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ios_app_btn marl50",
    attrs: {
      "href": "http://app.emulian.com/download/ios/"
    }
  })]), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('p')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01d39a98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/app/HomeAppBanner.vue
// module id = 134
// module chunks = 1